//
// Single point of contact for Vue
//
import Vue from 'vue'
import { mergeData } from 'vue-functional-data-merge'

export default Vue
export { mergeData }



//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/src/vue.js
// module id = null
// module chunks = 